/* istanbul ignore file - This needs to be refactored to test */
/**
 * @file
 * Behaviors for the Secondary Menu.
 */
!(function (Drupal, $) {
  'use strict';
  /**
   * Setup and attach the Secondary Menu behaviors.
   *
   * @type {Drupal~behavior}
   */

  Drupal.behaviors.secondaryNav = {
    attach: function attach(context) {
      const $secondaryWraper = $('.secondary-nav', context);

      if (!$secondaryWraper.length) {
        return;
      }

      const $secondaryToggle = $('.secondary-nav__toggle', context);
      const $secondaryNav = $('.secondary-nav__nav', context);

      // Apply active class on click.
      $secondaryToggle.on('click', function (e) {
        e.preventDefault();
        $secondaryNav.toggleClass('active');
        $secondaryToggle.toggleClass('active');
      });

      const $secondaryNavLinks = $('.secondary-nav__link', context);

      $secondaryNavLinks.each((index, element) => {
        const basePath = `${window.location.protocol}//${window.location.host}`;
        const fullUrl = `${basePath}${$(element).attr('href')}`;

        if (fullUrl === window.location.href) {
          $(element).toggleClass('active');
        }
      });
    },
  };
})(Drupal, jQuery);
